import { observer } from 'mobx-react-lite';
import React from 'react';

import DevPanel from 'devtools/DevPanel';
import { RIDE_DETAILS_MOCKS } from 'mocks/rideDetails';
import { rideDetailsStore } from 'pages/RideDetails/RideDetailsStore';

import styles from './styles.module.css';

/**
 * Preserves registry order while grouping consecutive mocks that share the
 * same `group` label. Mocks with no group land under an empty-string
 * bucket so the caller can decide whether to render a heading for it.
 *
 * @param {Array<{ group?: string }>} mocks
 * @returns {Array<{ heading: string, items: Array }>}
 */
const groupMocks = (mocks) => {
	const groups = [];
	mocks.forEach((mock) => {
		const heading = mock.group ?? '';
		const last = groups[groups.length - 1];
		if (last && last.heading === heading) {
			last.items.push(mock);
			return;
		}
		groups.push({ heading, items: [mock] });
	});
	return groups;
};

const MockDataToggle = observer(() => {
	const { activeMockId, setActiveMockId } = rideDetailsStore;

	const handleChange = (mockId) => {
		setActiveMockId(activeMockId === mockId ? null : mockId);
	};

	const groups = groupMocks(RIDE_DETAILS_MOCKS);

	return (
		<DevPanel title="Test data">
			{groups.map((group) => (
				<React.Fragment key={group.heading || 'ungrouped'}>
					{group.heading && <div className={styles.groupHeading}>{group.heading}</div>}
					{group.items.map((mock) => (
						<label key={mock.id} className={styles.label}>
							<input
								type="checkbox"
								checked={activeMockId === mock.id}
								onChange={() => handleChange(mock.id)}
							/>
							{mock.label}
						</label>
					))}
				</React.Fragment>
			))}
		</DevPanel>
	);
});

export default MockDataToggle;
